import styles from './Feedback.module.scss';
import { FeedbackForm } from './FeedbackForm';

export const Feedback = () => (
  <div className={styles.FeedbackPage}>
    <div className={styles.Header}>
      <h3 className={styles.Title} id="feedbackForm">
        Форма обратной связи
      </h3>
      <FeedbackForm />
      <h3 className={styles.Title}>Работа с обращениями</h3>
      <div className={styles.DescriptionLast}>
        Службой технической поддержки ФГИС &quot;Единый реестр контрольных (надзорных) мероприятий&quot; и ее подсистемы
        &quot;Единый реестр проверок&quot; обращения рассматриваются в течении трех рабочих дней с даты регистрации
        обращения.
      </div>
      Обращения принимаются:
      <ul className={styles.List}>
        <li>По форме обратной связи, расположенной выше (круглосуточно);</li>
        <li>По адресу электронной почты: erp_support@genproc.gov.ru (круглосуточно);</li>
        <li>
          <div className={styles.FlexBlock}>
            По номеру телефона
            <a className={styles.Phone} href="tel:8(800)100-35-38" rel="nofollow">
              8(800)100-35-38
            </a>
            (с 9 до 18:00 по московскому времени).
          </div>
        </li>
      </ul>
    </div>
  </div>
);
